import React, {Component, Fragment} from 'react'
import {message, Modal, Form, DatePicker, Popconfirm, Tooltip} from 'antd'
import {
    getOrderShort, reqOptRecord, reqRecordSave, reqRecordUpdate, reqRecordDel,
    baseUrl, reqOrderSendRecord,
} from '../../api';
import DeliveryView from './delivery-v'
import {subTimeStr, subStr} from "../../utills/subStringUtill";
import {DELIVERY_TYPE_MIX,} from "../../utills/constants";
import './delivery-step.less'
import ajax from "../../api/ajax";
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const confirm = Modal.confirm;
const formItemLayout = {
    labelCol: {
        span: 6,
    },
    wrapperCol: {
        span: 14,
    },
};
const hSteps = ['depart', 'send'];
class DeliveryStep extends Component {
    constructor(props) {
        super(props);
        this.state = {
            deliveryType: '',
            record: [],
            processShow: false,
            visible: false,
            okBtn: false,
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.getOrderShortFunc(orderId);
        this.setState({orderId: orderId});
    }

    saveOptAction = async (action, steps, type, values) => {
        await this.setState({okBtn: true});
        if (action == 'update') {
            const result = await reqRecordUpdate(values);
            if (result.code == '200') {
                this.setState({[type]: values.optDt});
                this.setDivs(steps, type, values.optDt);
                this.handleCancel();
            } else {
                message.error(result.message);
            }
        } else {
            const result = await reqRecordSave(values);
            if (result.code == '201') {
                this.setState({[type]: values.optDt});
                this.setDivs(steps, type, values.optDt);
                this.handleCancel();
                if (type === 'collect') {
                    const result = await reqOrderSendRecord(values);
                    if (result.code !== 201) {
                        message.error(result.message);
                    }
                }
            } else {
                message.error(result.message);
            }
        }
    };

    getOrderShortFunc = async (orderId) => {
        let result = await getOrderShort(orderId);
        if (result.code === 200) {
            this.setState({
                deliveryType: result.data.deliveryType,
                commitDt: result.data.commitDt,
                checkDt: result.data.checkDt,
                entryZone: result.data.entryZone,
                entryStation: result.data.entryStation,
            }, function () {
                this.getOptRecord(orderId);
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        } else {
            message.error(result.message)
        }
    };
    getOptRecord = async (orderId) => {
        const result = await reqOptRecord(orderId);
        if (result.code == '200') {
            const {deliveryType,} = this.state;
            //状态：collect:揽货,arrive:到达山口,declare:报关,systemPass:海关系统放行,pass:实货放行,transport:转运,dstkArrive:到达多斯特克,
            //     dstkOut:多斯特克出发,arriveDuisburg:到达目的城市,leaveDuisburg:清关仓库,destination:到达目的地)
            const data = {};
            for (let d of result.data) {
                data[d.optType] = d.optDt;
            }
            //新疆班列第二个点隐藏了，增加一个空点
            if (deliveryType === 'X') {
                result.data.splice(1, 0, {});
            }
            //css样式中第三个点隐藏了，所以增加了一个空点
            result.data.splice(2, 0, {});
            this.setDivs(result.data);
            this.setState(data);
        }
    };
    setDivs = (steps, optType, optDt) => {
        if (optType) {
            //时间新增 修改 删除时改变state值
            for (let s of steps) {
                if (s.optType === optType) {
                    Object.assign(s, {optType, optDt});
                    break;
                }
            }
        }
        const {action, mode} = this.props;
        const divs = (steps || []).map(d => {
                const step = <Fragment>
                    <div className="circle"><i></i></div>
                    <div className="title">{d.optName}</div>
                    <div className="time1">{d.optDt ? subStr(d.optDt) : ''}</div>
                    <div className="time2">{d.optDt ? subTimeStr(d.optDt) : ''}</div>
                </Fragment>;
                let className = 'info';
                if (action === 'edit') {
                    //可以编辑的情况：非霍尔果斯 || 霍尔果斯,非hmms,非查验、短驳、过境节点 || hmms,查验、短驳、过境节点编辑
                    /* if (customsPort !== 'Khorgos'
                     || (customsPort === 'Khorgos' && mode !== 'hmms' && hSteps.indexOf(d.optType) < 0)
                     || (mode === 'hmms' && (hSteps.indexOf(d.optType) > -1))) {*/
                    className = 'info itemHover';
                    /* }*/
                }
                if (className === 'info itemHover' && d.optType === 'pass') {
                    return <Popconfirm title="请确认已经导入正确货物信息，放行后则不能修改数据！"
                                       onConfirm={() => this.editDate(d.optType, d.optDt, true)}>
                        <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                            <div className='info itemHover'>{step}</div>
                        </div>
                    </Popconfirm>
                }
                if (className === 'info') {
                    return <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                        <Tooltip title="不可编辑">
                            <div className={className}>{step}</div>
                        </Tooltip>
                    </div>
                }
                return <div className={d.optDt ? 'proceIteam finish' : 'proceIteam'}>
                    <div className={className}
                         onClick={() => this.editDate(d.optType, d.optDt, className === 'info itemHover')}>
                        {step}
                    </div>
                </div>
            }
        );
        this.setState({divs, steps})
    };
    editDate = (type, optDt, editable) => {
        const {deliveryType} = this.state;
        if (editable) {
            let dataSource = this.props.dataSource;
            let flag = false;
            if (type == 'pass') {
                for (let i = 0; i < dataSource.length; i++) {
                    if (!!dataSource[i].deliveryNo || !DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)) {
                        flag = false;
                        if (optDt) {
                            this.props.form.setFieldsValue({optDt: moment(optDt, 'YYYY-MM-DD HH:mm:ss')});
                        }
                        this.setState({
                            visible: true,
                            type: type,
                            action: optDt ? 'update' : 'add',
                        });
                        return false;
                    } else {
                        flag = true
                    }
                }
                if (DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) && flag) {
                    message.error('放行时，请填写运单号');
                    return false;
                }
            } else {
                if (optDt) {
                    this.props.form.setFieldsValue({optDt: moment(optDt, 'YYYY-MM-DD HH:mm:ss')});
                }
                this.setState({
                    visible: true,
                    type: type,
                    action: optDt ? 'update' : 'add',
                });
            }

        }
    };

    handleOk = async (e) => {
        const {orderId, type, action, steps,} = this.state;
        const data = this.props.form.getFieldsValue();
        const values = {};
        values.orderId = orderId;
        values.optType = type;
        values.optDt = moment(data.optDt).format('YYYY-MM-DD HH:mm:ss');
        if (data.optDt) {
            if (type === 'collect') {
                let result = ajax(baseUrl + "/api/v1/p/collectCheck", {orderId: orderId});
                result.then((resp) => {
                    if (resp.code === 200) {
                        this.saveOptAction(action, steps, type, values);
                    } else if (resp.code === 205) {
                        confirm({
                            title: '确认框',
                            content: resp.message,
                            onOk: () => {
                                this.saveOptAction(action, steps, type, values);
                            }
                        });
                    } else {
                        message.error(resp.message)
                    }
                })
            } else {
                this.saveOptAction(action, steps, type, values);
            }
        } else {
            await this.setState({okBtn: true});
            if (action == 'update') {
                delete values.optDt;
                const result = await reqRecordDel(values);
                if (result.code == '200') {
                    if (type == 'pass') {
                        message.warning("已删除放行时间，请尽快通知管理员");
                    }
                    this.setState({[type]: values.optDt});
                    this.setDivs(steps, type, values.optDt);
                    this.handleCancel();
                } else {
                    message.error(result.message);
                }
            }
        }
    };

    handleCancel = e => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
            okBtn: false,
        });
    };

    spreadOpt = () => {
        const {processShow} = this.state;
        if (processShow) {
            this.setState({processShow: false})
        } else {
            this.setState({processShow: true})
        }
    };

    render() {
        const {getFieldDecorator,} = this.props.form;
        const {
            processShow, divs, visible, commitDt, checkDt, entryZone, entryStation, deliveryType,
        } = this.state;
        const className = deliveryType === 'X' ? ' hide' : '';
        return (
            <div>
                <DeliveryView checkDt={checkDt} entryZone={entryZone} entryStation={entryStation}
                          deliveryType={deliveryType}/>
                <div className={processShow ? "processBox processShow" + className : 'processBox' + className}>
                    <Modal
                        title="轨迹编辑"
                        visible={visible}
                        onOk={this.handleOk}
                        okButtonProps={{disabled: this.state.okBtn}}
                        onCancel={this.handleCancel}>
                        <Form {...formItemLayout}>
                            <Form.Item label="时间">
                                {getFieldDecorator('optDt', {})(<DatePicker showTime format="YYYY-MM-DD HH:mm:ss"/>)}
                            </Form.Item>
                        </Form>
                    </Modal>
                    <div className={commitDt ? 'proceIteam finish' : 'proceIteam'}>
                        <Tooltip title="不可编辑">
                            <div className="info">
                                <div className="circle"><i></i></div>
                                <div className="title">货运订单</div>
                                <div className="time1">{commitDt ? subStr(commitDt) : ''}</div>
                                <div className="time2">{commitDt ? subTimeStr(commitDt) : ''}</div>
                            </div>
                        </Tooltip>
                    </div>
                    {divs}
                    <div className="processShowBtn" onClick={this.spreadOpt}><span className="open">展开</span> <span
                        className="closed">收起</span>
                    </div>
                </div>
            </div>
        )
    }
}
const DeliveryStepForm = Form.create()(DeliveryStep);
export default DeliveryStepForm;